<template>
  <v-dialog v-model="shower" scrollable persistent max-width="500px">
    <v-card>
      <v-card-text class="pa-1 pt-1 pb-1 text-center" style="height:200px">
        <h2 style="fornt-size:30; color:#184966;" class="pa-1 pt-6 pb-1">{{  $t("packagenew.confrim_1") }}</h2>
        <h2 style="fornt-size:18; color:#184966;" class="pa-1 pt-6 pb-1 text-center">{{  $t("packagenew.confrim_2") }}</h2>
        <h2 style="fornt-size:18; color:#184966;" class="pa-0 pt-0 pb-1 text-center">{{  $t("packagenew.confrim_3") }}</h2>
      </v-card-text>
      <v-card-actions class="text-center pa-4">
        <v-spacer></v-spacer>
        <v-btn @click="$emit('closedialog')" class="pa-1 pt-0 white--text" color="red" dark>{{$t('keydetail.closeDialog')}}</v-btn>
        <v-btn :color="color.theme" class="pa-1 pt-0 white--text" @click="$emit('confiemupdate', typeaprove = 'Y')">{{
          $t("changeName.submit")
        }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
export default {
  props: ["show"],
   data: function(){ 
      return {
        typeaprove:""
    
      };
    },
  computed: {
    ...mapState(["username", "authorize", "account_active", "color"]),
    ...mapState({ processloader: "loading" }),
    ...mapGetters([
      "dataUsername",
      "dataAuthorize",
      "dataAccountActive",
      "dataAccesstoken",
      "dataBusinessProfile",
      "dataCitizenProfile",
      "dataDepartmentAccessId",
      "dataAccountId",
    ]),
    shower: {
      get() {
        if (this.show === true) {
          // console.log(this.status_response);
        }
        return this.show;
      },
    },
  },
};
</script>
